import { render, staticRenderFns } from "./IsciAlacakFormWizard.vue?vue&type=template&id=20f85e24"
import script from "./IsciAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./IsciAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports